import { RefObject } from 'react'
import { applyChange } from '../utils'

type Selection = {
  start?: number
  end?: number
}

export const insertTextAction = (
  textareaRef: RefObject<HTMLTextAreaElement>,
  value: string,
  onChange: (val: string) => void,
  text: string,
  selectionWithinInsert?: Selection,
) => {
  const el = textareaRef.current
  if (!el) return
  const s = el.selectionStart ?? 0
  const e = el.selectionEnd ?? s
  const start = Math.min(s, e)
  const end = Math.max(s, e)
  const before = value.slice(0, start)
  const after = value.slice(end)
  const insert = text
  const next = before + insert + after

  const len = insert.length
  const clamp = (n: number) => Math.max(0, Math.min(len, n))

  let selStart = before.length + len
  let selEnd = selStart

  if (selectionWithinInsert) {
    const relStart = selectionWithinInsert.start
    const relEnd = selectionWithinInsert.end
    if (typeof relStart === 'number' || typeof relEnd === 'number') {
      const startRel = clamp(typeof relStart === 'number' ? relStart : len)
      const endRel = clamp(
        typeof relEnd === 'number'
          ? relEnd
          : typeof relStart === 'number'
            ? relStart
            : len,
      )
      const a = Math.min(startRel, endRel)
      const b = Math.max(startRel, endRel)
      selStart = before.length + a
      selEnd = before.length + b
    }
  }

  applyChange(textareaRef, onChange, next, selStart, selEnd)
}
